import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SiteLogo } from "../SiteLogo";

const LINKS = [
  { id: "anasayfa", label: "Ana Sayfa" },
  { id: "hizmetler", label: "Hizmetlerimiz" },
  { id: "neden-biz", label: "Neden Biz?" },
  { id: "yayincilar", label: "Yayıncılarımız" },
  { id: "sss", label: "Sıkça Sorulan Sorular" },
  { id: "iletisim", label: "İletişim" },
];

export default function Navbar({ settings }) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("anasayfa");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      const sections = LINKS.map((l) => document.getElementById(l.id)).filter(Boolean);
      let current = "anasayfa";
      for (const s of sections) {
        if (s.getBoundingClientRect().top <= 120) current = s.id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b transition-colors duration-300 ${
        scrolled ? "bg-[#050505]/85 border-white/10" : "bg-[#050505]/40 border-white/5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <button onClick={() => goTo("anasayfa")} data-testid="nav-logo">
          <SiteLogo />
        </button>

        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => goTo(l.id)}
              className={`relative text-[13px] font-medium transition-colors pb-1 ${
                active === l.id ? "text-white" : "text-[#A0ABC0] hover:text-white"
              }`}
            >
              {l.label}
              <span
                className={`absolute left-0 -bottom-0.5 h-[2px] rounded-full bg-gradient-to-r from-[#0047FF] to-[#00F0FF] transition-all duration-300 ${
                  active === l.id ? "w-full" : "w-0"
                }`}
              />
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/giris"
            data-testid="nav-login-button"
            className="text-[13px] font-medium text-[#A0ABC0] hover:text-white transition-colors px-4 py-2"
          >
            Giriş Yap
          </Link>
          <button
            onClick={() => goTo("basvuru")}
            data-testid="nav-apply-button"
            className="btn-glow text-[13px] font-semibold text-white px-5 py-2.5 rounded-full"
          >
            Hemen Başvur
          </button>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/5 px-6 py-5 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => goTo(l.id)}
              className={`text-left text-sm font-medium ${active === l.id ? "text-cyan-300" : "text-[#A0ABC0]"}`}
            >
              {l.label}
            </button>
          ))}
          <div className="flex gap-3 pt-3 border-t border-white/5">
            <Link to="/giris" data-testid="mobile-nav-login" className="flex-1 text-center text-sm text-[#A0ABC0] border border-white/10 rounded-full py-2.5 hover:text-white">
              Giriş Yap
            </Link>
            <button onClick={() => goTo("basvuru")} data-testid="mobile-nav-apply" className="btn-glow flex-1 text-sm font-semibold text-white rounded-full py-2.5">
              Hemen Başvur
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
